import axios from './base'
const url = `/system`

export function checkToken(params={}){
  return axios.request({
    url: `${url}/check/token`,
    method: "get",
    params,
  })
}

// ========== 账号管理（后端 AccountService，/system/admin*） ==========
// GET /system/admin：分页列表，params 可带 keyword/company_id/status/page/page_size
// 返回 data:{list,total,page,page_size}，行含 person_name/company_name，不吐密码
export function getAdminList(params = {}) {
  return axios.request({
    url: `${url}/admin`,
    method: "get",
    params,
  })
}

// POST /system/admin：新增，data 含 username/company_id/person_id/is_super/status
// 初始密码由后端随机生成，在 res.data.password 一次性返回（前端不传密码）
export function createAdmin(data = {}) {
  return axios.request({
    url: `${url}/admin`,
    method: "post",
    data,
  })
}

// PUT /system/admin/{id}：编辑（username 后端忽略；本接口不改密码，改密码走「重置密码」）
export function updateAdmin(id, data = {}) {
  return axios.request({
    url: `${url}/admin/${id}`,
    method: "put",
    data,
  })
}

// DELETE /system/admin/{id}：软删除（超管账号/当前登录账号会被后端拦）
export function deleteAdmin(id, data = {}) {
  return axios.request({
    url: `${url}/admin/${id}`,
    method: "delete",
    data,
  })
}

// PUT /system/admin/{id}/status：启停 switch，data:{status}
export function changeAdminStatus(id, data = {}) {
  return axios.request({
    url: `${url}/admin/${id}/status`,
    method: "put",
    data,
  })
}

// PUT /system/admin/{id}/password：重置密码；后端一律置为系统默认初始密码，在 data.password 返回
export function resetAdminPassword(id, data = {}) {
  return axios.request({
    url: `${url}/admin/${id}/password`,
    method: "put",
    data,
  })
}


export function getPermissions(params = {}) {
  return axios.request({
    url: `${url}/permission/all`,
    method: "get",
    params,
  })
}

export function searchPermissions(params = {}) {
  return axios.request({
    url: `${url}/permissions`,
    method: "get",
    params,
  })
}

export function addPermission(data={}){
  return axios.request({
    url: `${url}/permission`,
    method: "post",
    data,
  })
}

export function getPermission(id, params={}){
  return axios.request({
    url:`${url}/permission/${id}`,
    method: "get",
    params,
  })
}

export function updatePermission(id, data={}){
  return axios.request({
    url:`${url}/permission/${id}`,
    method: "put",
    data,
  })
}

export function deletePermission(id, data={}){
  return axios.request({
    url:`${url}/permission/${id}`,
    method: "delete",
    data,
  })
}

// ================= 菜单管理（后端 MenuService，/system/menu*） =================

// 菜单列表（返回两级树 data:{list:[{...,children:[]}]}）
// 筛选：keyword 名称模糊 / type 1一级 2二级 / status 1显示 0隐藏
export function getMenus(params={}) {
  return axios.request({
    url:`${url}/menu`,
    method: "get",
    params,
  })
}

// 菜单树（全量显示中的菜单，供「上级菜单」下拉与角色授权共用）：data 即树数组
export function getMenuTree(params={}) {
  return axios.request({
    url:`${url}/menu/tree`,
    method: "get",
    params,
  })
}

// 新增菜单（type/parent_id/name 必填；二级菜单必填 path + component）
export function addMenu(data={}){
  return axios.request({
    url: `${url}/menu`,
    method: "post",
    data,
  })
}

// 编辑菜单（上级菜单须为一级菜单且不能选自己）
export function updateMenu(id, data={}){
  return axios.request({
    url:`${url}/menu/${id}`,
    method: "put",
    data,
  })
}

// 删除菜单（软删除；一级菜单连同其二级菜单一并删除）
export function deleteMenu(id, data={}){
  return axios.request({
    url:`${url}/menu/${id}`,
    method: "delete",
    data,
  })
}

// ================= 系统参数（后端 ConfigService，/system/config*） =================

// 参数列表（全站默认值 company_id=0，全量不分页）
// 筛选：keyword 参数键或名称模糊 / group basic|contact|reservation|content / input_type text|textarea|number|switch|select|image
export function getConfigList(params = {}) {
  return axios.request({
    url: `${url}/config`,
    method: "get",
    params,
  })
}

// 新增参数（config_key 新增后不可改；switch 的 config_value 传 "1"/"0"）
export function createConfig(data = {}) {
  return axios.request({
    url: `${url}/config`,
    method: "post",
    data,
  })
}

// 编辑参数（config_key 后端忽略，改不了）
export function updateConfig(id, data = {}) {
  return axios.request({
    url: `${url}/config/${id}`,
    method: "put",
    data,
  })
}

// 删除参数（软删除，仅超管）
export function deleteConfig(id, data = {}) {
  return axios.request({
    url: `${url}/config/${id}`,
    method: "delete",
    data,
  })
}

// ================= 角色管理（后端 RoleService，/system/role*） =================

// 角色列表（分页：list/total/page/page_size；筛选 keyword 名称或编码 / data_scope / status）
export function getRoleList(params = {}) {
  return axios.request({
    url: `${url}/role`,
    method: "get",
    params,
  })
}

// 角色启停（data:{status}）
export function changeRoleStatus(id, data = {}) {
  return axios.request({
    url: `${url}/role/${id}/status`,
    method: "put",
    data,
  })
}

// 读取权限树（分配权限弹窗）：返回 {role:{id,name,code,company_id}, menus:[tree]}
// 树节点含 can_view/can_create/can_update/can_delete/can_export/can_import 六位权限
export function getRoleMenus(id, params = {}) {
  return axios.request({
    url: `${url}/role/${id}/menus`,
    method: "get",
    params,
  })
}

// 保存权限（全量覆盖语义）：data:{items:[{menu_id,can_view,can_create,...}]}
export function saveRoleMenus(id, data = {}) {
  return axios.request({
    url: `${url}/role/${id}/menus`,
    method: "put",
    data,
  })
}

// 新增角色（name/code/company_id/data_scope 必填；超管可建系统预置 company_id=0，普通账号强制本公司）
export function createRole(data = {}) {
  return axios.request({
    url: `${url}/role`,
    method: "post",
    data,
  })
}

// 编辑角色（系统预置角色后端拒绝）
export function updateRole(id, data = {}) {
  return axios.request({
    url: `${url}/role/${id}`,
    method: "put",
    data,
  })
}

// 删除角色（软删除；系统预置 / 已分配给账号会被后端拦）
export function deleteRole(id, data = {}) {
  return axios.request({
    url: `${url}/role/${id}`,
    method: "delete",
    data,
  })
}


export function getTags(params = {}) {
  return axios.request({
    url: `${url}/tags/all`,
    method: "get",
    params,
  })
}

export function searchTags(params = {}) {
  return axios.request({
    url: `${url}/tags`,
    method: "get",
    params,
  })
}

export function addTag(data={}){
  return axios.request({
    url: `${url}/tag`,
    method: "post",
    data,
  })
}

export function getTag(id, params={}){
  return axios.request({
    url:`${url}/tag/${id}`,
    method: "get",
    params,
  })
}

export function updateTag(id, data={}){
  return axios.request({
    url:`${url}/tag/${id}`,
    method: "put",
    data,
  })
}

export function deleteTag(id, data={}){
  return axios.request({
    url:`${url}/tag/${id}`,
    method: "delete",
    data,
  })
}


export function getGroups(params = {}) {
  return axios.request({
    url: `${url}/groups/all`,
    method: "get",
    params,
  })
}

export function searchGroups(params = {}) {
  return axios.request({
    url: `${url}/groups`,
    method: "get",
    params,
  })
}
export function getCode(params = {}) {
  return axios.request({
    url: `${url}/group/qrcode`,
    method: "get",
    params,
  })
}
export function addGroup(data={}){
  return axios.request({
    url: `${url}/group`,
    method: "post",
    data,
  })
}

export function getGroup(id, params={}){
  return axios.request({
    url:`${url}/group/${id}`,
    method: "get",
    params,
  })
}

export function updateGroup(id, data={}){
  return axios.request({
    url:`${url}/group/${id}`,
    method: "put",
    data,
  })
}

export function deleteGroup(id, data={}){
  return axios.request({
    url:`${url}/group/${id}`,
    method: "delete",
    data,
  })
}
export function updateComprehensive(id, data={}){
  return axios.request({
    url:`${url}/group/comprehensive/${id}`,
    method: "put",
    data,
  })
}
export function updateMonth(id, data={}){
  return axios.request({
    url:`${url}/group/month/${id}`,
    method: "put",
    data,
  })
}
export function updateDeduction(id, data={}){
  return axios.request({
    url:`${url}/group/deduction/${id}`,
    method: "put",
    data,
  })
}

// ================= 人员管理（tb_sys_person） =================

// 人员列表（分页 + 筛选：keyword/company_id/type/position/status/page/page_size）
export function getPersonList(params = {}) {
  return axios.request({
    url: `${url}/person`,
    method: "get",
    params,
  })
}

// 人员详情（编辑回显用，手机号不脱敏）
export function getPersonDetail(id, params = {}) {
  return axios.request({
    url: `${url}/person/${id}`,
    method: "get",
    params,
  })
}

// 新增人员
export function createPerson(data = {}) {
  return axios.request({
    url: `${url}/person`,
    method: "post",
    data,
  })
}

// 编辑人员（只传需要修改的字段）
export function updatePerson(id, data = {}) {
  return axios.request({
    url: `${url}/person/${id}`,
    method: "put",
    data,
  })
}

// 删除人员（软删除）
export function deletePerson(id, data = {}) {
  return axios.request({
    url: `${url}/person/${id}`,
    method: "delete",
    data,
  })
}

// 可分配人员下拉（在职 + 接待/接送/讲解岗位，预约分配用）
export function getPersonServiceOptions(params = {}) {
  return axios.request({
    url: `${url}/person/service-options`,
    method: "get",
    params,
  })
}

// 人员分享二维码：返回 { id,name,position,position_text,url,qrcode,qrcode_error }
// qrcode 是 data:image/png;base64,... 可直接 <img :src>；生成失败时为空串，原因见 qrcode_error
export function getPersonShareQr(id) {
  return axios.request({
    url: `${url}/person/${id}/share-qr`,
    method: "get",
  })
}

// 员工下拉（选「推广员工 / 推荐人」用，不限岗位、不限状态，带所属公司名）
// 路径 person-options（不带 person/ 前缀）：避开 person/{id} 动态路由抢匹配
export function getPersonOptions(params = {}) {
  return axios.request({
    url: `${url}/person-options`,
    method: "get",
    params,
  })
}

// 批量设置推广二维码开关：{ ids: [1,2,3], qr_enabled: 1|0 }，单个切换传单元素数组
// 路径 qr-enabled（不带 person 前缀）：避开 person/{id} 动态路由抢匹配
export function setPersonQrEnabled(data = {}) {
  return axios.request({
    url: `${url}/qr-enabled`,
    method: "post",
    data,
  })
}

// ================= 公司管理（后端 CompanyService，/system/company*） =================

// 公司列表（全量不分页，前端按 parent_id 自建树；筛选 keyword/type/status）
export function getCompanyList(params = {}) {
  return axios.request({
    url: `${url}/company`,
    method: "get",
    params,
  })
}

// 上级公司下拉（仅正常状态，[{id,name}]）
export function getCompanyOptions(params = {}) {
  return axios.request({
    url: `${url}/company/options`,
    method: "get",
    params,
  })
}

// 新增公司（类型 1主公司/2合作公司；主公司后端强制顶级，「加下级」= 前端预填 parent_id）
export function createCompany(data = {}) {
  return axios.request({
    url: `${url}/company`,
    method: "post",
    data,
  })
}

// 编辑公司（上级公司不能选自己/自己的下级，后端防环）
export function updateCompany(id, data = {}) {
  return axios.request({
    url: `${url}/company/${id}`,
    method: "put",
    data,
  })
}

// 删除公司（有下级公司或挂有部门/人员会被后端拦，提示由拦截器统一弹）
export function deleteCompany(id, data = {}) {
  return axios.request({
    url: `${url}/company/${id}`,
    method: "delete",
    data,
  })
}

// 批量删除（data:{ids:[...]}，任一家命中删除约束则整批拒绝）
export function batchDeleteCompany(data = {}) {
  return axios.request({
    url: `${url}/company/batch`,
    method: "delete",
    data,
  })
}

// 启停公司（data:{status}）
export function changeCompanyStatus(id, data = {}) {
  return axios.request({
    url: `${url}/company/${id}/status`,
    method: "put",
    data,
  })
}

// ================= 部门管理（后端 DeptService，/system/dept*） =================

// 部门列表（全量不分页，前端按 parent_id 自建树；筛选 keyword/company_id/status）
// 行含 company_name/leader_name，不吐 deleted 字段
export function getDeptList(params = {}) {
  return axios.request({
    url: `${url}/dept`,
    method: "get",
    params,
  })
}

// 部门下拉（仅启用状态，name 为全路径如「桂林基地·接待组」；可传 company_id 过滤）
export function getDeptOptions(params = {}) {
  return axios.request({
    url: `${url}/dept/options`,
    method: "get",
    params,
  })
}

// 新增部门（「加子部门」= 前端预填 parent_id；上级须同公司）
export function createDept(data = {}) {
  return axios.request({
    url: `${url}/dept`,
    method: "post",
    data,
  })
}

// 编辑部门（上级不能选自己/自己的下级，后端防环）
export function updateDept(id, data = {}) {
  return axios.request({
    url: `${url}/dept/${id}`,
    method: "put",
    data,
  })
}

// 删除部门（有子部门或挂着人员会被后端拦，提示由拦截器统一弹）
export function deleteDept(id, data = {}) {
  return axios.request({
    url: `${url}/dept/${id}`,
    method: "delete",
    data,
  })
}

